import { cn } from '@/shadcn-ui/utils';

interface VehicleTileContainerProps {
  children: React.ReactNode;
  disable?: boolean;
  className?: string;
}

export default function VehicleTileContainer({
  children,
  disable = false,
  className,
}: VehicleTileContainerProps) {
  return (
    <div
      className={cn(
        `duration-50 text relative flex h-full flex-col justify-between overflow-hidden rounded-[16px] border-none bg-background ring-1 ring-border ${disable ? '' : 'cursor-pointer transition-shadow hover:shadow-shadow30'}`,
        className
      )}
    >
      {children}
    </div>
  );
}
